import { Navigate } from 'react-router-dom'

export default function UserActivityListingPage({ isWebview = false }) {
  return isWebview ? <Navigate to="/webview/plan" /> : <Navigate to="/plan" />
}
